import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { useAdminAuthSlice } from '../store/slices/adminAuth';

export default function RequireAdmin({ children }: { children: React.ReactNode }) {
  useAdminAuthSlice();
  const token = useAppSelector((s) => s.adminAuth?.token);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
